import type { CSSProperties, FC } from "react"

interface Props {
  className?: string
  style?: CSSProperties
}

/** Stroked arrow chevron (stroke follows `currentColor`). */
const ArrowRight: FC<Props> = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    viewBox="0 0 12 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M1.25 5.5 H8.5 M8.5 5.5 L5.2 2.35 M8.5 5.5 L5.2 8.65"
    />
  </svg>
)

export default ArrowRight
